import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from './api';
import { updateCryptoConnect, updateCryptoDisconnect } from './cryptoConnect';
import { fetchCurrentCustomer } from './customer';
import { clearUserData } from './entities';
const initialState = {
    status: 'init'
};
export const attemptExistingSessionAuthorization = createAsyncThunk('authentication/authorizeExistingSession', async (_, thunkApi) => {
    try {
        await (await api.instance).attemptAuthorization();
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
    await thunkApi.dispatch(fetchCurrentCustomer());
});
export const login = createAsyncThunk('authentication/login', async (credentials, thunkApi) => {
    try {
        await (await api.instance).login(credentials);
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
    await thunkApi.dispatch(fetchCurrentCustomer());
});
export const cryptoLogin = createAsyncThunk('authentication/cryptoLogin', async (credentials, thunkApi) => {
    try {
        await (await api.instance).cryptoLogin(credentials);
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
    await thunkApi.dispatch(fetchCurrentCustomer());
});
export const logout = createAsyncThunk('authentication/logout', async (credentials, thunkApi) => {
    try {
        await (await api.instance).logout();
        thunkApi.dispatch(clearUserData());
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
export const register = createAsyncThunk('authentication/register', async (credentials, thunkApi) => {
    try {
        await (await api.instance).register(credentials);
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
    await thunkApi.dispatch(fetchCurrentCustomer());
});
export const cryptoRegister = createAsyncThunk('authentication/cryptoRegister', async (credentials, thunkApi) => {
    try {
        await (await api.instance).cryptoRegister(credentials);
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
    await thunkApi.dispatch(fetchCurrentCustomer());
});
export const forgotPassword = createAsyncThunk('authentication/resetPassword/request', async (email, thunkApi) => {
    try {
        return await (await api.instance).forgotPassword({ email });
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
export const resetPassword = createAsyncThunk('authentication/resetPassword/update', async (data, thunkApi) => {
    try {
        return await (await api.instance).resetPassword(data);
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
function isLoginFulfilledAction(action) {
    return [
        attemptExistingSessionAuthorization.fulfilled.type,
        cryptoLogin.fulfilled.type,
        login.fulfilled.type
    ].includes(action.type);
}
function isRegisterFulfilledAction(action) {
    return [cryptoRegister.fulfilled.type, register.fulfilled.type].includes(action.type);
}
function isSubmittingAction(action) {
    return [
        attemptExistingSessionAuthorization.pending.type,
        cryptoLogin.pending.type,
        login.pending.type,
        logout.pending.type,
        forgotPassword.pending.type,
        resetPassword.pending.type
    ].includes(action.type);
}
function isRegisteringAction(action) {
    return [cryptoRegister.pending.type, register.pending.type].includes(action.type);
}
function isRejectedAction(action) {
    return action.type.startsWith('authentication/') && action.type.endsWith('/rejected');
}
const authenticationSlice = createSlice({
    name: 'authentication',
    initialState,
    reducers: {
        resetAuthentication: (state) => {
            state.error = undefined;
            state.status = 'init';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(logout.fulfilled, (state) => {
            state.status = 'loggedOut';
        })
            .addCase(forgotPassword.fulfilled, (state) => {
            state.status = 'success';
        })
            .addCase(resetPassword.fulfilled, (state) => {
            state.status = 'success';
        })
            .addCase(updateCryptoConnect.fulfilled, (state, action) => {
            state.status = 'success';
        })
            .addCase(updateCryptoDisconnect.fulfilled, (state, action) => {
            state.status = 'success';
        })
            .addMatcher(isRegisterFulfilledAction, (state, action) => {
            state.status = 'loggedIn';
        })
            .addMatcher(isRegisteringAction, (state) => {
            state.status = 'registering';
        })
            .addMatcher(isLoginFulfilledAction, (state, action) => {
            state.status = 'loggedIn';
        })
            .addMatcher(isSubmittingAction, (state) => {
            state.status = 'submitting';
        })
            .addMatcher(isRejectedAction, (state, action) => {
            state.error = action.payload;
            state.status = 'error';
        });
    }
});
export const resetAuthentication = authenticationSlice.actions.resetAuthentication;
export const authenticationReducer = authenticationSlice.reducer;
